"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryBoxSize = void 0;
/** Type for CategoryBox width, more info in documentation for enum values. */
let CategoryBoxSize = exports.CategoryBoxSize = /*#__PURE__*/function (CategoryBoxSize) {
  /** Mobile width: 120px, desktop width 160px, this is default value. */
  CategoryBoxSize["SMALL"] = "small";
  /** Mobile width: 160px, desktop width 160px. */
  CategoryBoxSize["MEDIUM"] = "medium";
  /** Mobile width: 160px, desktop width 240px. */
  CategoryBoxSize["LARGE"] = "large";
  return CategoryBoxSize;
}({});
